import React from 'react';

import { ChevronRightFill } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, IconButton } from '@lyearn/ui';

import { CategoryLayoutView } from '../../../types';

const CategoryExpandButton = ({
  hasChildren,
  isExpanded,
  layoutView,
  onClick,
}: {
  hasChildren: boolean;
  isExpanded: boolean;
  layoutView: CategoryLayoutView;
  onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}) => {
  const dimClass = layoutView === 'edit' ? 'h-24 w-24' : 'h-22 w-22';

  return (
    <Box className={dimClass}>
      {!hasChildren ? null : (
        <IconButton className={cn('flex-shrink-0', dimClass)} size="xs" onClick={onClick}>
          <ChevronRightFill
            aria-label="category-expand-button"
            className={cn(dimClass, 'rtl:rotate-180', { 'rotate-90 rtl:-rotate-90': isExpanded })}
            style={{ transition: 'transform .2s' }}
          />
        </IconButton>
      )}
    </Box>
  );
};

export default CategoryExpandButton;
